
import commonApi from '@/api/common';
import { defineComponent } from 'vue';
import { message as $message } from 'ant-design-vue';
import SupplementaryInformation from './components/supplementaryInformation.vue';
import CreateShop from './components/createShop.vue';
import CreateSuccess from './components/createSuccess.vue';
import CertifiedShop from './components/certifiedShop.vue';
import SubmitSuccess from './components/submitSuccess.vue';

export default defineComponent({
  name: 'Home',
  components: {
    SupplementaryInformation,
    CreateShop,
    CreateSuccess,
    CertifiedShop,
    SubmitSuccess,
  },
  data() {
    return {
      shopInfo: {
        shopName: '',
        shopVerifySubmitStatus: 0,
      },
      step: 2,
      AuthenticationStatus: 0,
    };
  },
  setup() {
    const error = (str: string) => {
      $message.error(str);
    };
    const success = (str: string) => {
      $message.success(str);
    };
    return {
      error,
      success,
    };
  },
  mounted() {
    this.getShopInfo();
  },
  methods: {
    goToAuthorize() {
      this.$router.push('/authorize');
    },
    // 进入创建店铺
    nextStep(num: number) {
      this.step = num;
    },
    nextAuthenticationStatus(num: number) {
      this.AuthenticationStatus = num;
    },
    getShopInfo() {
      interface Data{
        data: Shopinfo;
        success: boolean;
        message: string;
      }
      interface Shopinfo{
        shopName: string;
        shopVerifySubmitStatus: number;
      }
      const param = {
        memberId: localStorage.getItem('memberId'),
      };
      commonApi.getShopInfo(param).then(async ({ data, success, message }: Data) => {
        if (success) {
          this.shopInfo = data;
          if (!data.shopName) {
            const store = (this as any).$store;
            store.state.isShowGoBack = false;
          }
          if (!this.shopInfo.shopName) {
            this.step = 2;
            return;
          }
          this.$router.push('/logIn');

          // if (this.shopInfo.shopVerifySubmitStatus === 0) {
          //   this.step = 4;
          //   this.AuthenticationStatus = 0;
          //   return;
          // }
          // if (this.shopInfo.shopVerifySubmitStatus === 1) {
          //   this.step = 4;
          //   this.AuthenticationStatus = 1;
          //   return;
          // }
          console.log(data);
        } else {
          console.log(message);
          this.error(message);
        }
      });
    },
  },
});
